import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';

export const useUpdateStage = (totalStages: number) => {
  const { setOpenStageMap, setVisitedStageMap, visitedStageMap } = usePublicCalculatorContext();

  if (Object.keys(visitedStageMap).length >= totalStages) {
    return (stage: number) => {
      setOpenStageMap?.(() => ({ [stage + 1]: true }));
    };
  }

  return (stage: number) => {
    setVisitedStageMap?.(stage);
    const nextStage = stage + 1;
    setOpenStageMap?.(() => (nextStage <= totalStages ? { [nextStage]: true } : {}));
  };
};
